import { render, staticRenderFns } from "./FindingsFormDetails.vue?vue&type=template&id=f72ec2a2&"
import script from "./FindingsFormDetails.vue?vue&type=script&lang=js&"
export * from "./FindingsFormDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports